import type { EmailTemplateDocument } from '@opanuj/shared/types';
import { ref } from 'firebase/database';
import { useDatabase } from './useDatabase';
import { useListVals } from 'react-firebase-hooks/database';
import { withDefaultList } from './defaults';

export const useEmailTemplatesList = (): [EmailTemplateDocument[], boolean, Error | undefined] => {
  const database = useDatabase();
  const [templates, loading, error] = useListVals<EmailTemplateDocument>(ref(database, 'email_templates'), { keyField: 'id' });
  return [withDefaultList(templates), loading, error] as const;
};
